export const dateRangesOverlap = (date1Start: Date, date1End: Date, date2Start: Date, date2End: Date, includeBoundaries = false) => {
  if (includeBoundaries) {
    return date1Start <= date2End && date1End >= date2Start;
  }
  else {
    return date1Start < date2End && date1End > date2Start;
  }
};